// Token persistence (matches xapi-new key names so cross-app login works).

import {
  createEphemeralCredentialStore,
  sessionCredentialIdentity,
} from './ephemeral-credentials.js';

const ACCESS_KEY = 'xapi_access_token';
const REFRESH_KEY = 'xapi_refresh_token';
const ephemeralCredentials = createEphemeralCredentialStore();
const localStore = () => {
  try { return globalThis.window?.localStorage || globalThis.localStorage; }
  catch { return null; }
};

export const tokens = {
  getAccess() { try { return localStore()?.getItem(ACCESS_KEY) || null; } catch { return null; } },
  getRefresh() { try { return localStore()?.getItem(REFRESH_KEY) || null; } catch { return null; } },
  set(access, refresh) {
    try {
      const storage = localStore();
      if (!storage) return;
      const previousOwner = sessionCredentialIdentity(storage.getItem(ACCESS_KEY))?.owner;
      const nextOwner = sessionCredentialIdentity(access)?.owner;
      const ownerChanged = previousOwner !== nextOwner;
      if (ownerChanged) ephemeralCredentials.clear();
      storage.setItem(ACCESS_KEY, access);
      if (refresh) storage.setItem(REFRESH_KEY, refresh);
      else if (ownerChanged) storage.removeItem(REFRESH_KEY);
    } catch {}
  },
  clear() {
    try {
      localStore()?.removeItem(ACCESS_KEY);
      localStore()?.removeItem(REFRESH_KEY);
    } catch {}
    ephemeralCredentials.clear();
  },
};
